
// Mobile navigation state management:
try {

  // Init relevant menu style based on device width:
  var windowWidth = window.innerWidth
  var menuStyleBreakpoint = 768

  if (windowWidth >= menuStyleBreakpoint) {
    initDesktopMenu()
  } else {
    initMobileMenu()
  }

  // Switch out menu style if screen size changes after page load:
  window.addEventListener('resize', function () {
    var newWindowWidth = window.innerWidth

    // If current window width smaller than 768px and previous window width was larger, init mobile menu
    if (newWindowWidth < menuStyleBreakpoint && windowWidth >= menuStyleBreakpoint) {
      tearDownDesktopMenu()
      initMobileMenu()
    // else if current window width larger than 767px and was previously smaller, init desktop menu
    } else if (newWindowWidth >= menuStyleBreakpoint && windowWidth < menuStyleBreakpoint) {
      tearDownMobileMenu()
      initDesktopMenu()
    }

    windowWidth = newWindowWidth
  })


  function initMobileMenu () {
    /*
      Functions for managing visual state of main navigation on mobile.
      All visual state is handled via CSS - these functions just toggle
      classes to apply the correct state.
    */

    // Toggle menu panel (slides in/out from right of screen):
    $('.js-menu').on('click', '.js-toggle-mobile-nav', function (e) {
      e.preventDefault()

      newMenuState = {
        menuPanelVisible: !audienceMenuState.menuPanelVisible,
        tier1ActiveItem: audienceMenuState.tier1ActiveItem,
        tier2ActiveItem: audienceMenuState.tier2ActiveItem
      }

      updateMobileMenuState(newMenuState)

      // Toggle sub-menu (up to 2 levels deep). Opening new sub-menu should close any siblings:
    }).on('click', '.js-tier-toggle', function (e) {
      var itemNum = parseInt($(this).data('item'))
      var tierNum = parseInt($(this).data('tier'))

      if (isNaN(itemNum) || isNaN(tierNum)) return false

      // If mobile nav, trigger sub menu to open, else follow link:
      if (isMobileNav() || (!isMobileNav() && tierNum === 1)) e.preventDefault()

      var newMenuState

      if (tierNum === 1) {
        // Close item if already open:
        if (itemNum === audienceMenuState.tier1ActiveItem) itemNum = inactiveState

        newMenuState = {
          menuPanelVisible: audienceMenuState.menuPanelVisible,
          tier1ActiveItem: itemNum,
          tier2ActiveItem: audienceMenuState.tier2ActiveItem
        }
      } else {
        // Close item if already open:
        if (itemNum === audienceMenuState.tier2ActiveItem) itemNum = inactiveState

        newMenuState = {
          menuPanelVisible: audienceMenuState.menuPanelVisible,
          tier1ActiveItem: audienceMenuState.tier1ActiveItem,
          tier2ActiveItem: itemNum
        }
      }

      updateMobileMenuState(newMenuState)
    })
  }

  function tearDownMobileMenu () {
    $('.js-menu').off()
  }

  function initDesktopMenu () {
    // Close any open menus when tapping outside menu area:
    $(document).on('touchend', function (e) {
      e.stopPropagation()
      if (!$('.c-audience-nav').find($(e.target)).length) {
        $('.c-audience-nav .js-active').removeClass('js-active')
      }
    })

    // Open sub menu on first tap. If menu is already open, follow link on top level item:
    $('.js-tier-1-item > .js-tier-toggle').on('touchend', function (e) {
      var parent = $(this).parent('.js-tier-1-item')
      if (!parent.hasClass('js-active')) {
        e.preventDefault()
        // Close any open sibling menus:
        if ($('.js-active').length) {
          $('.js-active').removeClass('js-active')
        }
        parent.addClass('js-active')
      }
    })

  }

  function tearDownDesktopMenu () {
    $('.js-tier-1-item > .js-tier-toggle').off()
    $(document).off('touchend')
  }



  /*
    Helper vars/functions:
  */

  // Query menu panel element:
  var menuPanel = $('.js-mobile-nav-panel')

  /*
  * Menu state management:
  */

  // If state is set to -1, no menu on that tier is currently open:
  var inactiveState = -1

  // Class applied to active/open menu items (CSS used to style appropriately when class is present):
  var activeClass = 'js-active'

  // Initial menu state
  var audienceMenuState = {
    menuPanelVisible: false,
    tier1ActiveItem: inactiveState,
    tier2ActiveItem: inactiveState
  }

  // Function triggers any updates required given new state:
  function updateMobileMenuState(newMenuState) {
    if (audienceMenuState.menuPanelVisible !== newMenuState.menuPanelVisible) {
      toggleMenuVisibility(newMenuState.menuPanelVisible)
    } else if (audienceMenuState.tier1ActiveItem !== newMenuState.tier1ActiveItem) {
      toggleTierItem(newMenuState.tier1ActiveItem, 1)
    } else if (audienceMenuState.tier2ActiveItem !== newMenuState.tier2ActiveItem) {
      toggleTierItem(newMenuState.tier2ActiveItem, 2)
    }
  }

  // Toggles mobile menu panel (animates in/out from right or screen):
  function toggleMenuVisibility(isMenuVisible) {
    if (isMenuVisible) {
      menuPanel.addClass(activeClass)
      // Prevent scrolling of page behind menu overlay (see _shame.scss):
      $('body').addClass('_prevent-scrolling')
    } else {
      menuPanel.removeClass(activeClass)
      $('body').removeClass('_prevent-scrolling')
    }
    audienceMenuState.menuPanelVisible = isMenuVisible
  }

  // Open or close tier 1 & 2 sub menus:
  function toggleTierItem(itemNumber, tierNumber) {
    if (tierNumber === 1) {

      audienceMenuState.tier1ActiveItem = inactiveState
      audienceMenuState.tier2ActiveItem = inactiveState
      $('.js-tier-1-item.' + activeClass).removeClass(activeClass)
      $('.js-tier-2-item.' + activeClass).removeClass(activeClass)
      $(document).off('click', clickOutsideListener)
      toggleAriaExpandedLabel()

      // Close menu if set to inactive state:
      if (itemNumber == inactiveState) {
        var tier1Item = getTier1Item(audienceMenuState.tier1ActiveItem)
        if (tier1Item.length) {
          tier1Item.removeClass(activeClass)
          $(document).off('click', clickOutsideListener)
          toggleAriaExpandedLabel()
          audienceMenuState.tier1ActiveItem = inactiveState
        }
      } else {
        tier1Item = getTier1Item(itemNumber)
        if (tier1Item.length) {
          tier1Item.addClass(activeClass)
          $(document).on('click', clickOutsideListener)
          toggleAriaExpandedLabel()
          audienceMenuState.tier1ActiveItem = itemNumber
        }
      }
    } else {
      // Close menu if set to inactive state:
      if (itemNumber == inactiveState) {
        // Get currently active menu:
        var tier2Item = getTier2Item(audienceMenuState.tier2ActiveItem)
        if (tier2Item.length) {
          tier2Item.removeClass(activeClass)
          audienceMenuState.tier2ActiveItem = inactiveState
        }
      } else {
        // Toggle active tier 2 menu off:
        audienceMenuState.tier2ActiveItem = inactiveState
        $('.js-tier-2-item.' + activeClass).removeClass(activeClass)

        var tier2Item = getTier2Item(itemNumber)
        if (tier2Item.length) {
          tier2Item.addClass(activeClass)
          audienceMenuState.tier2ActiveItem = itemNumber
        }
      }
    }
  }

  // Return specified tier 1 item:
  function getTier1Item(itemNumber) {
    return $('.js-tier-1-item--' + itemNumber)
  }

  // Return specified tier 2 item from active tier 1 menu:
  function getTier2Item(itemNumber) {
    return $('.js-tier-1-item--' + audienceMenuState.tier1ActiveItem + ' .js-tier-2-item--' + itemNumber)
  }

  // Toggle aria-expanded attributes on dropdown trigger elements
  function toggleAriaExpandedLabel() {
    $('.js-tier-toggle').attr('aria-expanded', 'false')
    $('.js-active > .js-tier-toggle').attr('aria-expanded', 'true')
  }

  // Check if mobile version of nav is being shown
  function isMobileNav() {
    return $(window).width() < 768
  }

  // Function to close active dropdown menu when user clicks elsewhere on the page (doesn't apply to mobile nav)
  var clickOutsideListener = function (e) {
    e.stopPropagation()
    if (!isMobileNav() && !$('.c-audience-nav').find($(e.target)).length) {
      updateMobileMenuState({
        menuPanelVisible: audienceMenuState.menuPanelVisible,
        tier1ActiveItem: inactiveState,
        tier2ActiveItem: inactiveState
      })
    }
  }

  /*
   * Used to detect touch input. Not ideal but :hover-within selector used for non-touch devices causes funky
   * behaviour if not disabled on touch.
   */
  function isTouchDevice () {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) {
      return window.matchMedia(query).matches;
    }
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      return true;
    }
    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
  }

  if (isTouchDevice()) {
    $('body').addClass('js-touch-device')
  }

  // Focus search box when clicking search top level menu link
  $('.js-focus-search').on('click', function (e) {
    e.preventDefault()
    $('#header-search-keyword').focus()
    return false
  })

} catch (error) {
  console.error(error)
}
